export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/detail-back-arrow.8d9bb0aa-8d69bd.svg";